import React from 'react';

const CorematContext = React.createContext();

export default CorematContext;
